
// FIX THE CODE BELOW

document.addEventListener('DOMContentLoaded', function () {
  // open menu on click
  document.querySelectorAll(".sapje-responsive-navigation-burger").forEach(elem => {
    elem.addEventListener("click", () => {
      document.body.classList.toggle("navigation-open")
      document.querySelectorAll(".wp-block-sapje-responsive-navigation").forEach(content => {
        content.classList.toggle("open")
      })

    })
  })

  
  getCustomHeaderSize();

  
}, false);

const getCustomHeaderSize = () => {
  let root = document.documentElement;
  let scrollPosition = window.scrollY;
  let adminBar = document.getElementById("wpadminbar");
  let adminBarHeight = 0;
  if (adminBar) {
    adminBarHeight = adminBar.offsetHeight;
  }  
  let headerHeight = document.querySelector("header.wp-block-template-part").offsetHeight;
  let adminBarSize = scrollPosition > adminBarHeight ? 0 : adminBarHeight;
  root.style.setProperty("--custom-header-size", adminBarSize + headerHeight + "px");
}

window.addEventListener("scroll", getCustomHeaderSize, { passive: true });
window.addEventListener("resize", getCustomHeaderSize, { passive: true });


